import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a06af60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wb-sidebar-result-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "wb-sidebar-result-text" }, "Добавить аксессуары", -1 /* HOISTED */))
const _hoisted_3 = { class: "wb-sidebar-result-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SVGPlus = _resolveComponent("SVGPlus")!
  const _component_NavbarGreenButton = _resolveComponent("NavbarGreenButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-accessories'))),
      class: "wb-sidebar-result-btn"
    }, [
      _createVNode(_component_SVGPlus, { class: "wb-sidebar-result-img" }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NavbarGreenButton, {
        disabled: !this.storeData.getZeroPrice,
        text: "Заказать",
        onClick: $options.order
      }, null, 8 /* PROPS */, ["disabled", "onClick"]),
      (this.isDealer())
        ? (_openBlock(), _createBlock(_component_NavbarGreenButton, {
            key: 0,
            disabled: !this.storeData.getZeroPrice,
            text: "Запросить счет",
            onClick: $options.saveXml
          }, null, 8 /* PROPS */, ["disabled", "onClick"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("a", {
        class: "wb-sidebar-result-download",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.createPDF && $options.createPDF(...args)))
      }, "Скачать в PDF")
    ])
  ]))
}